"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentCardsContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("swiper/react");
var _swiper = require("swiper");
var _useDimension = require("../../hooks/useDimension");
var _PaymentCard = require("../PaymentCard/PaymentCard");
var _payment = require("../assets/icons/payment");
require("./PaymentCardsContainer.css");
require("swiper/css");
require("swiper/css/scrollbar");
var _excluded = ["platform", "cards"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var bankColors = {
  Bog: '#FF671B',
  Tbc: '#00ABED',
  Lib: '#E70D2F'
};
var PaymentCardsContainer = function PaymentCardsContainer(_ref) {
  var platform = _ref.platform,
    cards = _ref.cards,
    props = _objectWithoutProperties(_ref, _excluded);
  /*const { clientWidth } = useDimension();
  const count =
    platform === 'mob'
      ? 1.35
      : useMemo(() => {
          if (clientWidth < 680) return 1;
          if (clientWidth < 960) return 2;
          if (clientWidth < 1360) return 3;
          return 4;
        }, [clientWidth]);*/
  return /*#__PURE__*/_react.default.createElement(_react2.Swiper
  /*slidesPerView={platform === 'web' ? 'auto' : 1.35}*/, {
    slidesPerView: 'auto'
    /*spaceBetween={15}*/,
    threshold: 10,
    modules: [_swiper.FreeMode, _swiper.Scrollbar /*, Mousewheel*/],
    freeMode: {
      enabled: true,
      sticky: true,
      minimumVelocity: 0.05
    },
    scrollbar: {
      draggable: true,
      snapOnRelease: true
    }
    /*mousewheel={{ invert: false }}*/,
    className: 'swiper-cards'
  }, cards.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      key: index
      /*style={{ display: 'flex', justifyContent: 'center' }}*/
    }, /*#__PURE__*/_react.default.createElement(_PaymentCard.PaymentCard, _extends({
      id: item.id,
      platform: platform,
      logo: platform === 'web' ? _payment.BankLogos[item.bank] : _payment.BankLogosInv[item.bank],
      color: bankColors[item.bank],
      date: item.date,
      digits: item.digits
    }, props)));
  }));
};
exports.PaymentCardsContainer = PaymentCardsContainer;
PaymentCardsContainer.propTypes = {
  platform: _propTypes.default.oneOf(['web', 'mob']),
  actionType: _propTypes.default.oneOf(['deposit', 'withdraw']),
  cards: _propTypes.default.array,
  containerId: _propTypes.default.string,
  deleteHandler: _propTypes.default.func,
  callback: _propTypes.default.func
};
PaymentCardsContainer.defaultProps = {
  platform: 'web',
  actionType: 'deposit',
  cards: [{
    bank: 'Bog',
    date: '02/23',
    digits: '4596'
  }, {
    bank: 'Bog',
    date: '02/23',
    digits: '4596'
  }, {
    bank: 'Tbc',
    date: '02/23',
    digits: '4596'
  }, {
    bank: 'Tbc',
    date: '02/23',
    digits: '4596'
  }, {
    bank: 'Tbc',
    date: '02/23',
    digits: '4596'
  }],
  containerId: 'payment-container-deposit'
};